import { Button } from '@finviz/website'

export function TrialBadge() {
  return (
    <div className="hidden items-center gap-1 whitespace-nowrap rounded-md bg-gray-800 p-0.5 text-white md:flex">
      <div className="p-1 pr-0 text-2xs leading-none">
        Elite Trial ends in {FinvizSettings.remainingTrialDays}{' '}
        {FinvizSettings.remainingTrialDays === 1 ? 'day' : 'days'}
      </div>
      <Button as="a" href="/elite" theme="violet" rounding="small" size="small">
        Subscribe
      </Button>
    </div>
  )
}
